import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from '@material-ui/core';
import { Alert, AlertTitle, AlertProps } from '@material-ui/lab';
import { ResponseStatus } from '@servicestack/client';
import React, { FunctionComponent } from 'react';
interface IRequestAlertProps {
  responseStatus: ResponseStatus;
  icon?: IconProp;
  severity?: AlertProps['severity'];
}
const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: 'bold',
    paddingBottom: theme.spacing(2)
  }
}));
const useAlertStyles = makeStyles(theme => ({
  message: {
    flex: '1 1 auto'
  }
}));
const RequestAlert: FunctionComponent<IRequestAlertProps> = ({
  responseStatus,
  icon,
  severity
}) => {
  const classes = useStyles();
  const alertClasses = useAlertStyles();
  if (!responseStatus || !responseStatus.message && !responseStatus.stackTrace) {
    return null;
  }
  return <Alert icon={icon ? <FontAwesomeIcon fixedWidth icon={icon} /> : undefined} severity={severity} classes={alertClasses} data-sentry-element="Alert" data-sentry-component="RequestAlert" data-sentry-source-file="RequestAlert.tsx">
            {responseStatus.message && <AlertTitle className={classes.title}>{responseStatus.message}</AlertTitle>}
            {responseStatus.stackTrace && <pre>
                        {responseStatus.stackTrace}
                    </pre>}
        </Alert>;
};
export default RequestAlert;